import Landing from "./pages/landing";
import './App.css';

function App() {
  return ( 
    <div>
      <Landing/>
      {/* <Main/> */}
    </div>
   );
}

export default App;